module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content home-wrapper"
  }, [_c('div', {
    staticClass: "content-inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "full-w flex-column"
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "buttons_login",
    attrs: {
      "to": {
        name: 'auth.login'
      }
    }
  }, [_c('el-button', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.enter')))])], 1), _c('br'), _c('br')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "height": "100",
      "src": require("../../../../assets/images/kundan-logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0588d2c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/home/unsubscribed/unsubscribed.vue
// module id = 2896
// module chunks = 1